declare var grecaptcha: any;

import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RecaptchaComponent {

  public tokenClientRecaptcha: string = environment.captchaKey;
  //public resultCaptcha: boolean = false;

  constructor(
  	public dialogRef: MatDialogRef<RecaptchaComponent>
  ) { }
  
  resolved(captchaResponse: string) {
    this.confirmResponse(captchaResponse);
  }

  public confirmResponse(token: string) {
    grecaptcha.reset();
    this.dialogRef.close({
      status: token ? true : false,
      token: token
    });
  }

}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/resources/components/recaptcha/recaptcha.component.ts